// extracted by mini-css-extract-plugin
module.exports = {"FundingWalletDetails":"fundRequest_FundingWalletDetails__16YF_"};